import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { id: "login" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-xs-12 col-sm-6 col-md-4 col-md-offset-1" }
const _hoisted_5 = { class: "login" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<p>Log in</p><div class=\"alert alert-danger\" id=\"errorMessage1\" style=\"display:none;\"><button class=\"close\" data-close=\"alert\"></button><span style=\"color:red;\"> Invalid username or password </span></div><div class=\"alert alert-danger\" id=\"errorMessage2\" style=\"display:none;\"><button class=\"close\" data-close=\"alert\"></button><span style=\"color:red;\"> Please confirm your acceptance of the terms and conditions. </span></div><div class=\"alert alert-danger\" id=\"errorMessage\" style=\"display:none;\"><button class=\"close\" data-close=\"alert\"></button><span style=\"color:red;\"> Please enter username and password. </span></div>", 4)
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", null, "Username:", -1)
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", null, "Password", -1)
const _hoisted_14 = {
  class: "form-group",
  id: "checkbox"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", null, "I agree to the terms and conditions of using Customer Zone. ", -1)
const _hoisted_16 = { class: "form-group" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = {
  key: 0,
  class: "spinner-border spinner-border-sm",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Login now")
const _hoisted_20 = /*#__PURE__*/_createStaticVNode("<div class=\"col-xs-12 col-sm-6 col-md-6 col-md-offset-1\"><div class=\"content\"><p>All your online reports in one place:</p><ul><li>Market Intelligence</li><li>Smart Procurement</li><li>Document Exchange</li></ul><div class=\"questions\"><div class=\"text-q\"><div class=\"icon-q\"><span><img src=\"media/logos/key.png\"></span></div><p><span>You will get your login details provided by your Account Director</span></p></div></div><div class=\"questions\"><div class=\"text-q\"><div class=\"icon-q\"><span><img src=\"media/logos/lock.png\"></span></div><p>Forgot your account details?</p></div></div><div class=\"questions\"><div class=\"text-q\"><div class=\"icon-q\"><span><img src=\"media/logos/quest.png\"></span></div><p>Have questions or suggestions?</p><a href=\"https://www.eic.co.uk/contact/\" target=\"_blank\">Contact Support</a></div></div></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("form", {
            action: "/",
            onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmitLogin && _ctx.onSubmitLogin(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _withDirectives(_createElementVNode("input", {
                  class: "username form-control",
                  type: "text",
                  placeholder: "Username",
                  id: "txtUserName",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.email = $event))
                }, null, 512), [
                  [_vModelText, _ctx.email]
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _withDirectives(_createElementVNode("input", {
                  class: "password form-control",
                  type: "password",
                  placeholder: "Password",
                  id: "txtUserPassword",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.password = $event))
                }, null, 512), [
                  [_vModelText, _ctx.password]
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  name: "check",
                  id: "chkTerms",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.acceptedTerms = $event))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.acceptedTerms]
                ]),
                _hoisted_15
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("button", {
                  type: "submit",
                  disabled: !_ctx.isFormValid || _ctx.isLoading,
                  id: "Login"
                }, [
                  (_ctx.isLoading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_18))
                    : _createCommentVNode("", true),
                  _hoisted_19
                ], 8, _hoisted_17)
              ])
            ])
          ], 32)
        ]),
        _hoisted_20
      ])
    ]),
    (_ctx.showToastFlag)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(['toast-box', _ctx.toastType === 'success' ? 'bg-success' : 'bg-danger'])
        }, _toDisplayString(_ctx.toastMessage), 3))
      : _createCommentVNode("", true)
  ]))
}